import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

/**
 * Confirmação de ação destrutiva no backoffice.
 *
 * Existe porque o mesmo gesto tinha três tratamentos: cupom, faixa de KM e
 * horário apagavam no clique, sem pergunta e sem desfazer; avaliações e pedidos
 * perguntavam por `window.confirm`, que ignora o tema e o idioma da interface e
 * chega como um alerta do navegador no meio da tela.
 *
 * O texto é obrigatório e deve dizer o que será apagado — "Excluir o cupom
 * PIZZA10?" e não "Tem certeza?". Quem confirma precisa reconhecer o registro.
 */
export function DialogConfirmar({
  aberto,
  titulo,
  descricao,
  textoConfirmar = 'Excluir',
  destrutivo = true,
  processando = false,
  aoConfirmar,
  aoCancelar,
}: {
  aberto: boolean;
  titulo: string;
  descricao?: string;
  textoConfirmar?: string;
  destrutivo?: boolean;
  processando?: boolean;
  aoConfirmar: () => void;
  aoCancelar: () => void;
}): JSX.Element {
  return (
    <Dialog open={aberto} onClose={processando ? undefined : aoCancelar} maxWidth="xs" fullWidth>
      <DialogTitle>{titulo}</DialogTitle>

      {descricao && (
        <DialogContent>
          <DialogContentText>{descricao}</DialogContentText>
        </DialogContent>
      )}

      <DialogActions>
        <Button onClick={aoCancelar} disabled={processando} color="inherit">
          Cancelar
        </Button>
        <Button
          onClick={aoConfirmar}
          disabled={processando}
          variant="contained"
          color={destrutivo ? 'error' : 'primary'}
        >
          {textoConfirmar}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
